// import Vue from 'vue'
import { PartecipanteItem } from "@/models/ricercaGaranzie/partecipanteItem";

import api from "@/services/api";
import { Component, Prop, Watch } from "vue-property-decorator";
import gridComponentBase from "./grid/gridComponentBase.vue";

import helpers from "@/helpers";
import { storicoModificheAdesioneItem } from "@/models/prodotti/storicoModificheAdesioneItem.js";

const _ENDPONT = api.endpoint.STORICO_MODIFICHE_ADESIONE;

interface ModificaVisualizzata {
	label: string;
	prima: string | number | boolean | null;
	dopo: string | number | boolean | null;
  	tipo?: 'text' | 'date' | 'currency' | 'boolean' | 'partecipanti';
}

@Component({})
export default class storicoModificheAdesione extends gridComponentBase {
	@Prop({ default: () => 0 }) adesioneID: number;
	@Prop({ default: () => ({}) }) adesione: any;

	storicoModificheAdesione: storicoModificheAdesioneItem[] = [];

	created() {
		var self = this;
		api.get(`${_ENDPONT}/${this.adesioneID}`).then(res => {
			self.storicoModificheAdesione = res;
		});
	}


	getPartecipanti(data: string) : string {
		if(!data || data.trim() === "") {
			return "";
		}
		var array = JSON.parse(data) as PartecipanteItem[];
		let partecipanti: string[] = [];
		if (array && array.length > 0) {
			partecipanti = array.map(function(item) {
				return `${item.Cognome} ${item.Nome}`;
			});
		}
		return partecipanti.join(", ");
	}

	getTestoTipoApplicazione(data: any) {
		return data.secondoImporto
			? helpers.getTipoApplicazioneLabelAlloggi(data.tipoApplicazione)
			: "Alloggi";
	}

	getUlterioriDatiValore(item) {
		return helpers.getUlterioriDatiValore(item);
	}

	getDatiAggiuntivi(item) {
		return item.datiAggiuntivi
			? JSON.parse(atob(item.datiAggiuntivi))
			: null;
	}

	aggiungiModifica( modifiche: ModificaVisualizzata[], label: string, prima: string | number | boolean | null, dopo: string | number | boolean | null, tipo: ModificaVisualizzata["tipo"] = "text" ): void {
		if (prima !== dopo) {
			modifiche.push({
				label,
				prima,
				dopo,
				tipo
			});
		}
	}

	getVariazioni(s: storicoModificheAdesioneItem): ModificaVisualizzata[] {
		const modifiche: ModificaVisualizzata[] = [];


		this.aggiungiModifica(modifiche, 'Distributore', s.distributorePrima, s.distributoreDopo);
		this.aggiungiModifica(modifiche, 'Destinazione', s.destinazionePrima, s.destinazioneDopo);
		this.aggiungiModifica(modifiche, 'Nazionalità', s.nazionalitaPrima, s.nazionalitaDopo);
		this.aggiungiModifica(modifiche, 'Inizio Viaggio', s.inizioViaggioPrima, s.inizioViaggioDopo, 'date');
		this.aggiungiModifica(modifiche, 'Fine Viaggio', s.fineViaggioPrima, s.fineViaggioDopo, 'date');
		this.aggiungiModifica(modifiche, 'Durata Viaggio', s.durataViaggioPrima, s.durataViaggioDopo);
		this.aggiungiModifica(modifiche, 'Importo Viaggio a persona', s.importoViaggioPrima, s.importoViaggioDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Numero Alloggi', s.numeroAlloggiPrima, s.numeroAlloggiDopo);
		this.aggiungiModifica(modifiche, 'Secondo Importo', s.secondoImportoPrima, s.secondoImportoDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Numero Partecipanti', s.numeroPartecipantiPrima, s.numeroPartecipantiDopo);
		this.aggiungiModifica(modifiche, 'Elenco Partecipanti', s.partecipantiElencoPrima, s.partecipantiElencoDopo, 'partecipanti');
		
		this.aggiungiModifica(modifiche, 'Codice Coupon', s.codiceCouponPrima, s.codiceCouponDopo);
		this.aggiungiModifica(modifiche, 'Dati Aggiuntivi', s.datiAggiuntiviPrima, s.datiAggiuntiviDopo);
		this.aggiungiModifica(modifiche, 'Dati Extra', s.datiExtraPrima, s.datiExtraDopo);

		// PREMI

		this.aggiungiModifica(modifiche, 'Premio per Persona', s.totalePremioPersonaPrima, s.totalePremioPersonaDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Imposte per Persona', s.totalePremioPersonaImpostePrima, s.totalePremioPersonaImposteDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Totale Premio', s.totalePremioPrima, s.totalePremioDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Di cui Imposte', s.totalePremioImpostePrima, s.totalePremioImposteDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Premio Imponibile', s.totalePremioNettoPrima, s.totalePremioNettoDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Oneri Accessori', s.totaleMarkupPrima, s.totaleMarkupDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Di cui Commissioni', s.commissioniPrima, s.commissioniDopo, 'currency');
		this.aggiungiModifica(modifiche, 'RA Commissioni', s.totaleRitenutaPrima, s.totaleRitenutaDopo, 'currency');
		this.aggiungiModifica(modifiche, 'Da Pagare', s.totalePremioDaPagarePrima, s.totalePremioDaPagareDopo, 'currency');

		// MAGGIORI INFORMAZIONI

		//this.aggiungiModifica(modifiche, 'Importo Sconto', s.importoScontoPrima, s.importoScontoDopo, 'currency');
		this.aggiungiModifica(modifiche, 'ID Prodotto', s.pacchettoIDPrima, s.pacchettoIDDopo);
		this.aggiungiModifica(modifiche, 'Prodotto', s.pacchettoPrima, s.pacchettoDopo);
		this.aggiungiModifica(modifiche, 'Note', s.notePrima, s.noteDopo);
		this.aggiungiModifica(modifiche, 'Riferimento Pratica', s.riferimentoPraticaPrima, s.riferimentoPraticaDopo);
		this.aggiungiModifica(modifiche, 'Adeguatezza', s.adeguatezzaPrima, s.adeguatezzaDopo, 'boolean');
		// this.aggiungiModifica(modifiche, 'Codice RUI', s.codiceRUIPrima, s.codiceRUIDopo);
		// this.aggiungiModifica(modifiche, 'IVASS', s.chkIVASSPrima, s.chkIVASSDopo, 'boolean');
		// this.aggiungiModifica(modifiche, 'Termini', s.chkTerminiPrima, s.chkTerminiDopo, 'boolean');
		// this.aggiungiModifica(modifiche, 'Privacy', s.chkPrivacyPrima, s.chkPrivacyDopo, 'boolean');
		// this.aggiungiModifica(modifiche, 'Commerciale', s.chkCommercialePrima, s.chkCommercialeDopo, 'boolean');

		// ELENCO PARTECIPANTI

		//this.aggiungiModifica(modifiche, 'Immagine Elenco Partecipanti', s.imageFilePartecipantiPrima, s.imageFilePartecipantiDopo);

		// ALTRI CAMPI

		//this.aggiungiModifica(modifiche, 'Pratiche Complementari', s.praticheComplementariPrima, s.praticheComplementariDopo);
		//this.aggiungiModifica(modifiche, 'Recupero Credito', s.recuperoCreditoPrima, s.recuperoCreditoDopo, 'currency');
		//this.aggiungiModifica(modifiche, 'Parametro Prodotto', s.anagraficaProdottoParametriItemIDPrima, s.anagraficaProdottoParametriItemIDDopo);
		//this.aggiungiModifica(modifiche, 'Parametro Pacchetto', s.anagraficaPacchettiParametriItemIDPrima, s.anagraficaPacchettiParametriItemIDDopo);
		this.aggiungiModifica(modifiche, 'Aderente', s.aderentePrima, s.aderenteDopo);
		this.aggiungiModifica(modifiche, 'Aderente partecipante', s.aderenteIsPartecipantePrima, s.aderenteIsPartecipanteDopo, 'boolean');

		// ...

		return modifiche;
	}

	formatValore( valore: string | number | boolean | null,	tipo: ModificaVisualizzata["tipo"]	): string {
		if (valore === null || valore === undefined) {
			return "-";
		}

		switch (tipo) {
			case "date":
				return this.$options.filters.dateToString(valore);

			case "currency":
				// return Number(valore).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
				return kendo.toString(parseFloat(valore as string || '0'), `c2`);
			case "boolean":
				return valore ? "Sì" : "No";
			case 'partecipanti':
      			return this.getPartecipanti(valore as string);

			default:
				return String(valore);
		}
	}
}
